import React from 'react'
import kebabCase from 'lodash.kebabcase'
import { Button } from '@/components/atoms/Button/Button'
import { Image } from '@/components/atoms/Image/Image'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'
import { CTAIntegrationsBannerProps } from './types'

export function CTAIntegrationBannerSection({ pageContent, instance, ...props }: CTAIntegrationsBannerProps) {
  const { content } = pageContent?.blok || instance || {}
  const { heading, button, bg_image_left, bg_image_right, bg_image_mobile, subheading } = content || props

  return (
    <section
      className="relative mx-auto max-w-screen-desktop overflow-hidden flex flex-col items-center bg-primary-100 p-24 pt-48 tablet:py-64 my-24 bg-gradient-to-r from-transparent via-primary-100 via-[percentage:10%_90%] to-transparent max-tablet:[mask:linear-gradient(to_bottom,_black_0%,_black_75%,_transparent_100%)] tablet:[mask:linear-gradient(to_right,_transparent_0%,_black_10%,_black_90%,_transparent_100%)]"
      id={heading ? kebabCase(heading) : ''}
    >
      <div className="relative max-tablet:[mask:linear-gradient(to_bottom,_black_0%,_black_75%,_transparent_100%)] tablet:[mask:linear-gradient(to_right,_transparent_0%,_black_10%,_black_90%,_transparent_100%)] w-full tablet:my-auto tablet:mx-24  text-center z-10 mb-32 tablet:mb-0">
        {bg_image_left && bg_image_right && (
          <div className="w-full justify-between items-center flex flex-col tablet:flex-row gap-24">
            <Image
              fixed={false}
              fluid
              data={bg_image_left}
              loading="eager"
              className="object-contain hidden tablet:block -ml-[calc(100%-40rem)] tablet-lg:-ml-[calc(90%-35rem)] tablet-xl:-ml-[calc(80%-40rem)] netbook:-ml-24"
              imgClassName="max-w-90 "
            />
            <div className="tablet-lg:max-w-34 lg:max-w-52 mx-auto flex-grow flex-col flex items-center">
              <h2 className="text-headingM-mobile netbook:text-headingM font-bold mb-16 font-poppins text-text-dark-900">
                {heading}
              </h2>
              {subheading && <Paragraph className="text-bodyL text-text-dark-600">{subheading}</Paragraph>}
              {button.length > 0 &&
                button.map((item) => (
                  <Button {...item} className="mt-24 w-full tablet:w-fit tracking-sm">
                    {item.text}
                  </Button>
                ))}
            </div>
            <Image
              fixed={false}
              fluid
              data={bg_image_right}
              loading="eager"
              className="object-contain hidden tablet:block -mr-[calc(100%-40rem)] tablet-lg:-mr-[calc(90%-35rem)] tablet-xl:-mr-[calc(80%-40rem)]  netbook:-mr-24"
              imgClassName="max-w-90"
            />
            {bg_image_mobile && (
              <Image
                fixed={false}
                fluid
                data={bg_image_mobile}
                loading="eager"
                className="object-contain tablet:hidden block w-full"
                imgClassName="w-full"
              />
            )}
          </div>
        )}
      </div>
    </section>
  )
}
